import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import { Tooltip as ReakitTooltip } from 'reakit';
import { View } from '../View';
import { useTooltipContext } from './Tooltip.Context';
import * as styles from './Tooltip.styles';
var TooltipPopoverView = styles.TooltipPopoverView;

function TooltipContent(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'TooltipContent'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className"]);

  var _useTooltipContext = useTooltipContext(),
      tooltip = _useTooltipContext.tooltip;

  var classes = cx(styles.TooltipContent, className);
  return /*#__PURE__*/React.createElement(ReakitTooltip, Object.assign({
    as: View
  }, otherProps, tooltip, {
    className: classes,
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(TooltipPopoverView, null, children));
}

export default contextConnect(TooltipContent, 'TooltipContent');